import {useState} from 'react';
import {BankSelectWidget} from "./BankSelectWidget";

export const BankAccountWidget = ({accountName, accountId, setAccountId, onApiFail, altText, props}) => {
    const [active, setActive] = useState(false);

    const onActive = () => {
        setActive (true);
    }

    const onInactive = () => {
        setActive(false);
    }

    const onSelectAccountId = (accountId) => {
        if (setAccountId) {
            setAccountId(accountId);
        }
        setActive(false);
    }

    if (active) {
        return <BankSelectWidget accountId={accountId} setAccountId={onSelectAccountId} onApiFail={onApiFail} altText={altText} onInactive={onInactive}/>
    } else {
        return <div onClick={onActive} style={{cursor: 'pointer', color: "#108ee9"}}>
            {accountName}
        </div>
    }
}